import Splide from "@splidejs/splide";

function initializeCaseStudyTeaser() {
  const pagination = document.querySelector(".case-study-teaser__pagination");

  document
    .querySelectorAll(".case-study-teaser__slider")
    .forEach(function (slider) {
      const customerVoices = new Splide(slider, {
        arrows: false,
        pagination: false,
        width: "100%",
        autoWidth: true,
        gap: 16,
        trimSpace: false,
      }).mount();

      customerVoices.on("move", updateElements);

      function updateElements() {
        updatePagination();
        updateArrows();
      }

      function updatePagination() {
        if (pagination) {
          const current = pagination.querySelector(".pagination__num--current");
          current.innerText = customerVoices.index + 1;
        }
      }

      function updateArrows() {
        const arrows = pagination.querySelectorAll(".pagination__nav");

        if (customerVoices.index === 0) {
          arrows[0].classList.add("pagination__nav--disabled");
        } else {
          arrows[0].classList.remove("pagination__nav--disabled");
        }

        if (customerVoices.index === customerVoices.length - 1) {
          arrows[1].classList.add("pagination__nav--disabled");
        } else {
          arrows[1].classList.remove("pagination__nav--disabled");
        }
      }

      function listenForArrows() {
        if (!pagination) {
          return;
        }
        const arrows = pagination.querySelectorAll(".pagination__nav");
        if (arrows) {
          arrows.forEach(function (arrow) {
            arrow.addEventListener("click", function (e) {
              e.preventDefault();

              if (arrow.classList.contains("pagination__nav--disabled")) {
                return;
              }

              if (arrow.classList.contains("pagination__nav--prev")) {
                customerVoices.go("<");
              } else {
                customerVoices.go(">");
              }
            });
          });
        }
      }

      listenForArrows();
    });
}

export default initializeCaseStudyTeaser;
